import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="min-h-screen flex items-center justify-center px-4 safe-top safe-bottom">
      <div className="card p-6 w-full max-w-sm text-center">
        <h1 className="text-xl font-bold mb-2">Page not found</h1>
        <p className="text-sm text-ink-muted mb-6">
          That route doesn't exist yet.
        </p>
        <Link to="/home" className="btn-primary">
          Back to home
        </Link>
      </div>
    </main>
  );
}
